exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".app-container .head[data-v-b1220fca]{display:-webkit-box;display:-ms-flexbox;display:flex}.app-container .head .name[data-v-b1220fca]{width:200px}.app-container .roles-table[data-v-b1220fca]{margin-top:30px}.app-container .permission-tree[data-v-b1220fca]{margin-bottom:30px}.app-container .function-icon img[data-v-b1220fca]{cursor:pointer;width:14px}.app-container .page[data-v-b1220fca]{text-align:center;margin-top:20px}\n", ""]);

// exports
